<template>
  <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
</template>
<script>
import Toast from '@/components/Toast'
import {
  fetchRedpacket,
  doRedpacket,
  fetchBusRedpacket,
  doBusRedpacket,
  doRedpacketFission,
  fetchRedpacketFission,
  fetchPointsInfoByIds,
  receivePoints,
} from '@/services/redpacket';
import { errorReport } from '@/utils/index.js'
import tujiaRedirect from '@/utils/tujiaRedirect.js'
import tujialogin from '@/utils/tujialogin.js'
import { geocoder } from '@/services/city'
import { searchfilteritem } from '@/services/filter'
import urlHelper from '@lib/utils/urlHelper'
import Cookies from 'js-cookie'
import { throttle } from '@/utils'
import tjCookie from '@/utils/tjCookie'
import { TCShare } from '@/components/sharePopup';
import { POINT_TYPE_ENUM, REDPACKET_TYPE_ENUM } from './config/redPackConfig';
import tokenManager from '@/business/tokenManager.js'

export default {
  mixins: [tujiaRedirect, tujialogin],
  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    const { isTujiaAppEnv, isCtripAppEnv, isQunarAppEnv } = this.platformEnv
    return {
      isAppEnv: isTujiaAppEnv || isCtripAppEnv || isQunarAppEnv,
      showToast: false,
      msg: '',
      autoGetRedpacketId: this.$route.query.autoGetRedpacketId,
      fId: Number(this.$route.query.fId),
      remoteUrl: {},
      ids: [],
      busIds: [], // 商户红包ID
      uiItems: [],
      timeOutArray: [],
      interval: null,
      redpackets: []
    }
  },
  watch: {
    async payLoad(newVal) { // 观察者，观察桥接响应对象
            // 积分类型
      if (this.isPointsTypeCpd) {
        this.handleUsePointsType(newVal);
        return;
      }
      // 分享红包在未领取情况下，唤起分享
      if (this.isActiveFission && newVal && newVal.shareRedPacket && newVal.status === 1) {
        if (this.isAppEnv) {
          const isLogin = await this.isLogin()
          // 此处不建议依赖全局的登录
          if (!isLogin) {
            const { autoGetRedpacketId, fId } = this.$route.query
            const redirect = `${window.location.href}${autoGetRedpacketId ? '&autoGetRedpacketId=' + autoGetRedpacketId : ''}${fId ? '&fId=' + fId : ''}`
            this.goLoginPage({ redirect })
          } else {
            TCShare()
          }
          return
        } else {
          this.$toast('请点击页面右上角进行分享')
          return
        }
      }
      if (newVal && newVal.toUse) {
        this.redirectToHouseListPage(newVal)
      }
      console.log('newVal----->', newVal)
      if (newVal && newVal.status === 1) {
        if (newVal.channelType == 2) {
          this.doBusRedpach(newVal.id)
        } else {
          this.doRedpacketHandler(newVal.id)
        }
      } else if (newVal && newVal.status === 3) {
        this.redirectToHouseListPage(newVal)
      } else if (newVal && newVal.status === 4) {
        this.doShowToast('好可惜，红包抢完了')
      } else if (newVal && newVal.status === 5) {
        // 已使用
        // this.doShowToast('您已经使用过啦')
      } else if (newVal && newVal.status === 0) {
        this.doShowToast('活动未开始，请稍后再试')
        this.throttleFetch()
      }
    }
  },
  async mounted() {
    const platform = this.platformEnv
    console.log('platform----->', platform)
    try {
      if (this.isPointsTypeCpd) {
        this.fetchPointsInfo();
        return;
      }
      this.compProps.mate.items.forEach((redpacket) => {
        let item = null
        if (redpacket.channelType == 2) {
          this.busIds.push(redpacket.id)
          this.uiItems.push({
            ...redpacket,
            flagId: redpacket.id
          })
        } else {
          if (this.$root.isOldUser !== undefined && redpacket.userType && this.$root.isOldUser) {
            item = redpacket.oldUser
          } else if ((this.$root.isOldUser !== undefined && redpacket.userType && !this.$root.isOldUser) ||
            (this.$root.isOldUser === undefined && redpacket.userType)) {
            item = redpacket.newUser
          } else {
            item = redpacket
          }
          const idList = item.id.split(',')
          this.ids = this.ids.concat(idList)
          this.uiItems.push({
            ...item,
            flagId: idList[0]
          })
        }
      })
      this.fetchRedpacket()
      this.throttleFetch = throttle(3000, this.fetchRedpacket)
    } catch (e) {
      errorReport(e)
    }
  },
  beforeDestroy() {
    this.interval && clearInterval(this.interval)
  },
  computed: {
    /**
     * 是否从登陆页返回
     * @param {int} id 红包id
     */
    isFromLoginPage() {
      return window.localStorage.getItem('isFromLoginPage') && window.localStorage.getItem('isFromLoginPage') === '1'
    },
    isActiveFission() {
      return ['T20230310142815', 'T20230310191107'].indexOf(this.$route.query.id) > -1
    },
    isSharedPeople() { // 被分享者
      if (this.fId && this.fId !== Number(tjCookie.getUserId())) {
        return true
      } else {
        return false
      }
    },
    /**
     * 积分类型
     */
    isPointsTypeCpd() {
      return this.compProps.mate.items?.every(
        (item) => Number(item.channelType) == REDPACKET_TYPE_ENUM.POINTS
      );
    },
  },
  methods: {
    report(eventname, ext) {
      try {
        window._fas &&
          window._fas.setCustomTrack({
            eventname,
            ext,
          });
      } catch (err) {}
    },
    reportCouponReceive(isSuccess, requestParams, responseData) {
      this.report(isSuccess ? 'C_HOME_CMS_COUPON_RECEIVE_SUCCESS' : 'C_HOME_CMS_COUPON_RECEIVE_FAIL', {
        request_params: requestParams,
        response_data: responseData,
      });
    },
    // 获取积分信息
    fetchPointsInfo() {
      this.compProps.mate.items.forEach((redpacket) => {
        this.ids.push(redpacket.id);
        this.uiItems.push({
          ...redpacket,
          flagId: redpacket.id,
          // 积分类型
          status: POINT_TYPE_ENUM.CLAIM_NOW,
        });
      });
      fetchPointsInfoByIds(this.ids)
        .then((res) => {
          const isSuccess = res?.ret;
          if (!isSuccess) {
            this.report('PWA_CMS_QUERY_POINTS_INFO_ERROR', {
              activityIdList: this.ids,
              error: res,
            });
            return;
          }
          const list = res?.data?.userRightVos || [];
          list.forEach((item) => {
            const uiItem = this.uiItems.find(
              (ui) => ui.id === item.rigConfigCode
            );
            if (uiItem) {
              uiItem.status = item.statusCode;
              uiItem.toast = item.toast;
            }
          });
          this.$emit('init', this.uiItems);
        })
        .catch((err) => {
          this.report('PWA_CMS_QUERY_POINTS_INFO_ERROR', {
            activityIdList: this.ids,
            error: err,
          });
        });
    },
    // 积分逻辑
    handleUsePointsType(newVal) {
      if (!newVal) return;
      switch (newVal.status) {
        case POINT_TYPE_ENUM.CLAIM_NOW:
          this.handleRecivePoints(newVal.id);
          break;
        case POINT_TYPE_ENUM.CLAIMED:
          this.doShowToast('积分已领取');
          break;
        case POINT_TYPE_ENUM.USE_NOW:
          this.redirectToHouseListPage(newVal);
          break;
        case POINT_TYPE_ENUM.SOLD_OUT:
          this.doShowToast('积分已抢完');
          break;
        default:
          break;
      }
    },
    // 领取积分
    handleRecivePoints(id) {
      receivePoints(id)
        .then((res) => {
          const isSuccess = res?.ret;
          if (isSuccess) {
            this.$emit('finish', { type: 'recivePointsSuccess', data: { id } });
            this.doShowToast('领取成功');
          } else {
            this.doShowToast(res?.errmsg || '领取失败');
            this.report('PWA_CMS_RECEIVE_POINTS_ERROR', {
              activityId: id,
              error: res?.errmsg,
            });
          }
        })
        .catch((err) => {
          this.report('PWA_CMS_RECEIVE_POINTS_ERROR', {
            activityId: id,
            error: err,
          });
          this.doShowToast(err?.errmsg || '领取失败');
        });
    },
    async fetchRedpacket() {
      const { ids = [], busIds = [] } = this
      let ret = null
      if (ids.length) {
        ret = await fetchRedpacket(this.ids)
      }
      if (busIds.length) {
        ret = await fetchBusRedpacket(this.busIds)
        if (ret && ret.errcode === 170011) {
          this.doShowToast('请先登录途家房东账号')
        }
      }
      if (ret && ret.errcode === 0) {
        let redpackets = []
        // 单个红包内配置多个红包id的时候 红包状态以第一个红包为准
        ret.data.redpacketActivities.forEach((item) => {
          const idx = this.uiItems.find((redpacket) => {
            return redpacket.flagId === item.activityConfigId
          })
          if (idx) {
            redpackets.push({
              ...item,
              ...idx
            })
          }
        })

        // 活动裂变-被分享者，登录-打接口领取，给分享/被分享领
        if (this.isActiveFission && this.isSharedPeople && this.$root.isLogin) {
          redpackets.forEach((item) => {
            if (item.shareRedPacket) {
              this.doRedpacketFission(item.id)
            }
          })
        }
        // 查询活动裂变-老客+未领券+登陆状态
        if (this.isActiveFission && this.$root.isLogin && this.$root.isOldUser) {
          const count = await this.fetchRedpacketFission(redpackets)
          redpackets.forEach((item) => {
            if (!item.receive && item.shareRedPacket) {
              item.fissionCount = count
            }
          })
        }

        await this.autoGetRedpacket(redpackets)
        this.beginTimeOut(redpackets)
        this.redpackets = redpackets
        this.$emit('init', redpackets)
      } else {
        this.$emit('init', [])
      }
    },
    /**
     * 活动裂变，老客-获取领券人数
     */
    async fetchRedpacketFission(redpackets) {
      let one = ''
      redpackets.forEach((item) => {
        if (!item.receive && item.shareRedPacket) {
          one = item.id
        }
      })
      try {
        const ret = await fetchRedpacketFission([one])
        const { data = {} } = ret
        const count = (data.fissionData && data.fissionData[one]) || 0
        return count
      } catch (err) { return 0 }
    },
    /**
     * 领商户红包
     * @param {int} id 红包id
     */
    async doBusRedpach(id = '') {
      try {
        const ids = id.split(',')
        const param = ids.map((item) => {
          return {
            activityCode: item,
            couponCode: ''
          }
        })
        const ret = await doBusRedpacket(param)
        const { data = {} } = ret
        if (data.success) {
          this.doShowToast('领取成功')
          this.$emit('finish', { type: 'doRedpacket', data: { id: id } })
        } else {
          data.tip && this.doShowToast(data.tip)
        }
        console.log(ret)
      } catch (e) {
        this.doShowToast('系统开小差了，一会再试试吧')
        errorReport(e)
      }
    },
    /**
     * 领红包
     * @param {int} id 红包id
     */
    async doRedpacketHandler(id) {
      let ids = []
      let requereRedPacketInfo
      let requestParams = { ids, requereRedPacketInfo }
      try {
        // 这个埋点方案不是很好。想想以后改进一下。其他地方同。
        if (window._vds && window._vds.track) {
          window._vds.track(`${this.$root.isMobile ? 'H5' : 'PC'}_coupons_cms`, {
            [`${this.$root.isMobile ? 'H5' : 'PC'}_coupons_cms_bian`]: id,
            'activityid_cms': this.$root.promotionId
          })
        }
        requereRedPacketInfo = this.compProps.mate.privateProps.hasRedPackModel
        const hasDialog = this.compProps.mate.privateProps.hasDialog
        const idList = id.split(',')
        ids = idList.map((item) => {
          return {
            activityCode: item,
            couponCode: ''
          }
        })
        requestParams = {
          ids,
          requereRedPacketInfo,
        }
        const ret = await doRedpacket({ ids, requereRedPacketInfo })
        console.log('doRedpacket-->', this.compProps)
        console.log('ret-->', ret)
        const sendCouponRes = ret?.data?.sendCouponRes || []
        const isSuccess = ret?.errcode === 0 && sendCouponRes.length && sendCouponRes.every((item) => { return item.errorCode === 0 })
        this.reportCouponReceive(isSuccess, requestParams, ret)
        if (ret && ret.errcode === 0 && ret.data && ret.data.sendCouponRes) {
          // 判断是否都领取成功
          let resVo = sendCouponRes.length && sendCouponRes.every((item) => { return item.errorCode === 0 })
          if (resVo) {
            if (requereRedPacketInfo && !hasDialog) {
              // 领取成功，弹层展示获得的红包列表
              console.log('serviceCom:' + JSON.stringify(ret.data.redPacketInfos))
              this.$emit('finish', { type: 'doRedpacketAndShowListToast', data: { id: id, recivedRepackList: (ret.data && ret.data.redPacketInfos) || [] } })
            } else if (hasDialog && !requereRedPacketInfo) {
              // 领取成功，展示立即使用弹窗
              this.$emit('finish', { type: 'receiveRedpacketAndShowListToast', data: { id: id } })
            } else {
              // 领取成功，toast提示语
              if (this.isActiveFission && id === 'BnbCt_vSaYL') {
                this.doShowToast('参加成功，去选好房吧')
              } else {
                this.doShowToast('领取成功')
              }
              this.$emit('finish', { type: 'doRedpacket', data: { id: id } })

              // 处理活动裂变领取成功后，立刻跳转列表页
              if (this.isActiveFission && id === 'BnbCt_vSaYL') {
                // 去使用红包
                let redpacket = this.redpackets.find((item) => {
                  return item.id === id
                })
                this.redirectToHouseListPage(redpacket)
              }
            }
          } else {
            const failVo = sendCouponRes.find((item) => { return item.errorCode !== 0 })
            this.$toast(failVo?.errorMsg || '领取失败')
          }
        } else if (ret && ret.errcode === 55004) {
          const redirect = `${window.location.href}${id ? '&autoGetRedpacketId=' + id : ''}`
          this.goLoginPage({ redirect })
        } else if (ret && ret.errcode === 165002) {
          // 去使用红包
          let redpacket = this.redpackets.find((item) => {
            return item.id === id
          })
          this.redirectToHouseListPage(redpacket)
          this.$emit('finish', { type: 'redpacketDone', data: { id: id } })
        } else if (ret && ret.errcode === 165001) {
          this.doShowToast('好可惜，红包抢完了')
          this.$emit('finish', { type: 'overRedpacket', data: { id: id } })
        } else {
          this.doShowToast(ret?.errmsg || '领取失败')
        }
      } catch (e) {
        this.reportCouponReceive(false, requestParams, e)
        this.doShowToast('系统开小差了，一会再试试吧')
        errorReport(e)
      }
    },
    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    },

    /**
     * 派发红包
     */
    async doRedpacketFission(id) {
      try {
        const idList = id.split(',')
        const ids = idList.map((item) => {
          return {
            activityCode: item,
            couponCode: ''
          }
        })
        const ret = await doRedpacketFission({ ids, ownerMemberId: this.fId })
        const { data = {} } = ret
        if (data.success) {
          // this.doShowToast('领取成功')
          this.$emit('finish', { type: 'doRedpacket', data: { id: id } })
        }
      } catch (e) { console.log(e) }
    },

    /**
     * 自动领红包
     * @param {int} id 红包id
     */
    async autoGetRedpacket(redpackets) {
      redpackets.forEach(async (item, index) => {
        // 从登陆页返回时，触发红包领取
        if (this.isFromLoginPage && !item.receive && this.autoGetRedpacketId && item.id === this.autoGetRedpacketId) {
          window.localStorage.removeItem('isFromLoginPage')
          // 登录成功后注入userid和token
          const { tjuserid = '', tjusertoken = '' } = this.$route.query
          const isFvt = location.href.includes('fvt')
          const domain = isFvt ? 'fvt_tujia.com_PortalContext_' : 'tujia.com_PortalContext_'
          !!tjuserid && Cookies.set(`${domain}UserId`, tjuserid)
          // !!tjusertoken && Cookies.set(`${domain}UserToken`, tjusertoken)
          if (!!tjusertoken) {
            await tokenManager.set(tjusertoken)
          }
          this.doRedpacketHandler(item.id)
        }
      })
      return
    },
    /**
     * 跳转至房屋列表
     */
    async redirectToHouseListPage(redpack) {
      // console.log(this.compProps)
      let CITYREG = new RegExp(/CITYID/, 'g')
      let geoInfo = await geocoder({ parameter: {} })
      let urlobj = urlHelper.getQueryStringByStringUrl(redpack.activeLink)
      let isSupportFilter = await searchfilteritem({ cityId: (geoInfo && geoInfo.data && geoInfo.data.cityId) || 48, filterValue: urlobj.cds || '' })
      let cityId = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.cityId : 48
      let cityName = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.cityName : '北京'
      let isOverSea = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.oversea ? 2 : 1 : 1
      let _maplink = redpack.mpLink && redpack.mpLink.replace(CITYREG, cityId).replace('城市名称', cityName).replace('城市类型', isOverSea)
      let redirectUrl = {
        mpLink: _maplink,
        appLink: redpack.appLink && redpack.appLink.replace(CITYREG, cityId),
        activeLink: redpack.activeLink && redpack.activeLink.replace(CITYREG, cityId),
        isJumpApp: this.compProps.mate.privateProps.isJumpApp
      }
      this.doRedirect(redirectUrl, true)
    },
    /**
     * 开始倒计时
     * @param {Object} redpackets 红包
     */
    beginTimeOut(redpackets) {
      this.timeOutArray = []
      redpackets.forEach((item) => {
        item.activityType === 3 && item.activityStatus === 1 && item.countDown && this.timeOutArray.push(parseInt(item.countDown / 1000, 10))
      })
      if (this.timeOutArray.length) {
        this.timeOuntRun()
      }
    },
    /**
     * 倒计时函数
     */
    timeOuntRun() {
      this.interval = setInterval(this.calculTime, 1000)
    },
    /**
     * 倒计时计算
     */
    calculTime() {
      this.timeOutArray.forEach((item, index) => {
        this.timeOutArray[index] = item - 1
        if (item === 0) {
          this.fetchRedpacket()
        }
      })
      this.timeOutArray.filter((item) => {
        return item > 0
      })
      if (this.timeOutArray.length === 0) {
        clearInterval(this.interval)
      }
    }
  }
}
</script>
